'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  position: relative;\n  width: 100%;\n'], ['\n  display: inline-block;\n  position: relative;\n  width: 100%;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  border-style: solid;\n  border-color: ', ';\n  border-width: 1px;\n  border-radius: 4px;\n  width: 100%;\n  height: 48px;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  padding-right: 36px;\n  color: ', ';\n  font-size: 16px;\n  box-sizing: border-box;\n  background-color: ', ';\n  -moz-appearance: none; /* Firefox */\n  -webkit-appearance: none; /* Safari and Chrome */\n  appearance: none;\n'], ['\n  border-style: solid;\n  border-color: ', ';\n  border-width: 1px;\n  border-radius: 4px;\n  width: 100%;\n  height: 48px;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  padding-right: 36px;\n  color: ', ';\n  font-size: 16px;\n  box-sizing: border-box;\n  background-color: ', ';\n  -moz-appearance: none; /* Firefox */\n  -webkit-appearance: none; /* Safari and Chrome */\n  appearance: none;\n']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  right: 1px;\n  top: 12px;\n  pointer-events: none;\n  fill: none;\n  stroke: #6E0AD6;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n'], ['\n  position: absolute;\n  right: 1px;\n  top: 12px;\n  pointer-events: none;\n  fill: none;\n  stroke: #6E0AD6;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0px;\n  right: 11px;\n  top: 12px;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  background: none;\n  border-color: transparent;\n  outline: none;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.7;\n  }\n'], ['\n  padding: 0px;\n  right: 11px;\n  top: 12px;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  background: none;\n  border-color: transparent;\n  outline: none;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.7;\n  }\n']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  pointer-events: none;\n  fill: none;\n  stroke: #6E0AD6;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n'], ['\n  pointer-events: none;\n  fill: none;\n  stroke: #6E0AD6;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Wrapper = _styledComponents2.default.span(_templateObject);
var Select = _styledComponents2.default.select(_templateObject2, function (props) {
  return props.hasError ? '#ff4444' : '#d2d2d2';
}, function (props) {
  return props.disabled ? '#d2d2d2' : '#4a4a4a';
}, function (props) {
  return props.disabled ? '#f6f6f6' : '#ffffff';
});
var Icon = _styledComponents2.default.svg(_templateObject3);
var ClearButton = _styledComponents2.default.button(_templateObject4);
var ClearIcon = _styledComponents2.default.svg(_templateObject5);
var SelectInput = function (_Component) {
  (0, _inherits3.default)(SelectInput, _Component);
  function SelectInput(props) {
    (0, _classCallCheck3.default)(this, SelectInput);
    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectInput.__proto__ || (0, _getPrototypeOf2.default)(SelectInput)).call(this, props));
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    _this.buildItems = _this.buildItems.bind(_this);
    return _this;
  }
  (0, _createClass3.default)(SelectInput, [{
    key: 'handleChange',
    value: function handleChange(event) {
      if (this.props.onChange) {
        this.props.onChange(event);
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: 'handleClear',
    value: function handleClear(event) {
      if (this.props.onClear) {
        this.props.onClear(event);
      }
    }
  }, {
    key: 'buildItems',
    value: function buildItems() {
      var _props = this.props,
        emptyItem = _props.emptyItem,
        items = _props.items;
      var firstItem = emptyItem ? [_react2.default.createElement('option', {
        key: '-1',
        value: ''
      }, emptyItem)] : [];
      if (!Array.isArray(items)) return firstItem;
      return firstItem.concat(items.map(function (item, index) {
        return _react2.default.createElement('option', {
          key: index.toString(),
          value: item.id
        }, item.name);
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        className = _props2.className,
        disabled = _props2.disabled,
        value = _props2.value,
        hasError = _props2.hasError,
        emptyItem = _props2.emptyItem,
        clearButton = _props2.clearButton;
      return _react2.default.createElement(Wrapper, null, _react2.default.createElement(Select, {
        className: className,
        disabled: disabled,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: value || '',
        hasError: hasError
      }, this.buildItems()), (!value || value === '' || value === emptyItem || !clearButton) && _react2.default.createElement(Icon, {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '34',
        height: '24',
        viewBox: '0 0 34 24'
      }, _react2.default.createElement('polyline', {
        points: '6 9 12 15 18 9'
      })), clearButton && value && value !== emptyItem && _react2.default.createElement(ClearButton, {
        onClick: this.handleClear
      }, _react2.default.createElement(ClearIcon, {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24'
      }, _react2.default.createElement('line', {
        x1: '18',
        y1: '6',
        x2: '6',
        y2: '18'
      }), _react2.default.createElement('line', {
        x1: '6',
        y1: '6',
        x2: '18',
        y2: '18'
      }))));
    }
  }]);
  return SelectInput;
}(_react.Component);
SelectInput.defaulProps = {
  hasError: false
};
SelectInput.propTypes = {
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onClear: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  clearButton: _propTypes2.default.bool,
  items: _propTypes2.default.array,
  //eslint-disable-line
  value: _propTypes2.default.string,
  emptyItem: _propTypes2.default.string,
  hasError: _propTypes2.default.bool,
  className: _propTypes2.default.string
};
exports.default = SelectInput;